import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { X, Archive } from 'lucide-react'
import { Button } from '../ui/button'
import toast from '../../utilities/toast'

function ArchiveDialog({ isOpen, onClose, onConfirm, userName }) {
  const [isArchiving, setIsArchiving] = useState(false)

  const handleArchive = async () => {
    setIsArchiving(true)
    try {
      await onConfirm()
      toast.success('Conversation archived')
    } catch {
      toast.error('Failed to archive conversation')
    } finally {
      setIsArchiving(false)
    }
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-900">Archive Conversation</h2>
          <Button onClick={onClose} variant="ghost" size="icon" disabled={isArchiving}>
            <X className="w-5 h-5" />
          </Button>
        </div>

        <div className="p-4">
          <div className="flex items-start gap-3 p-3 mb-4 bg-gray-50 border border-gray-200 rounded-lg">
            <Archive className="w-5 h-5 text-gray-600 flex-shrink-0 mt-0.5" />
            <div className="text-sm text-gray-900">
              <p className="font-medium mb-1">Archive conversation with {userName}?</p>
              <p>This will hide the conversation from your list. You can still access it later if needed.</p>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-end gap-2 p-4 border-t border-gray-200">
          <Button onClick={onClose} variant="outline" disabled={isArchiving}>
            Cancel
          </Button>
          <Button onClick={handleArchive} disabled={isArchiving} className="bg-gray-600 hover:bg-gray-700">
            {isArchiving ? 'Archiving...' : 'Archive'}
          </Button>
        </div>
      </div>
    </div>
  )
}

ArchiveDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  userName: PropTypes.string
}

export default ArchiveDialog
